import "./FieldLabel.scss";

import { InfoIcon, Text, TextProps, Tooltip } from "@fluentui/react-northstar";
import * as React from "react";

export type FieldLabelProps = {
  label: React.ReactNode;
  note?: React.ReactNode;
  tooltip?: React.ReactNode;
} & TextProps;

export const FieldLabel: React.FC<FieldLabelProps> = ({
  className,
  label,
  tooltip,
  note,
  ...textProps
}) => {
  return (
    <div className={className}>
      <Text content={label} weight="bold" {...textProps} />

      {tooltip && (
        <Tooltip
          trigger={
            <InfoIcon outline xSpacing="before" size="small" className="field-label__tooltip" />
          }
          content={tooltip}
        />
      )}

      {note && (
        <Text content={note} weight="light" size="smaller" styles={{ marginLeft: "1rem" }} />
      )}
    </div>
  );
};
